export default __webpack_public_path__ + "static/media/i-error.99bd691e.svg";